import React from 'react';
import logo from './logo.svg';
import './App.css';

const App = ({touren}) => (
	<ul>
		{touren.map (rad =>
			<li key={rad.id}>{rad.name} Start: {rad.route}</li>
		)}
	</ul>
);

export default App;
